<template>
  <div class="dashboard-skeleton-wrapper">
    <div class="skeleton-banner"></div>
    <main class="skeleton-main-content-wrapper">
      <!-- <div class="skeleton-header">
        <div class="skeleton-rect title"></div>
        <div class="skeleton-buttons-header">
          <div class="skeleton-rect button"></div>
          <div class="skeleton-rect button"></div>
        </div>
      </div> -->

      <section class="skeleton-dashboard-filters">
        <div class="skeleton-rect filter-item datepicker"></div>
        <div class="skeleton-rect filter-item device-selector"></div>
        <div class="skeleton-rect filter-item campaign-select"></div>
        <div class="skeleton-rect filter-item export-button"></div>
      </section>

      <div class="skeleton-dashboard-frames">
        <div class="skeleton-rect frame-item"></div>
        <div class="skeleton-rect frame-item"></div>
        <div class="skeleton-rect frame-item"></div>
        <div class="skeleton-rect frame-item"></div>
      </div>

      <div class="skeleton-expandable-wrapper">
        <div class="skeleton-expandable-item">
          <div class="skeleton-rect expandable-title"></div>
          <div class="skeleton-rect expandable-line"></div>
          <div class="skeleton-rect expandable-line short"></div>
          <div class="skeleton-rect expandable-line"></div>
          <div class="skeleton-rect expandable-line short"></div>
        </div>
        <div class="skeleton-expandable-item">
          <div class="skeleton-rect expandable-title"></div>
          <div class="skeleton-rect expandable-line"></div>
          <div class="skeleton-rect expandable-line short"></div>
          <div class="skeleton-rect expandable-line"></div>
          <div class="skeleton-rect expandable-line short"></div>
        </div>
        <div class="skeleton-expandable-item chart">
          <div class="skeleton-rect chart-area"></div>
          <div class="skeleton-chart-selectors">
            <div class="skeleton-rect selector"></div>
            <div class="skeleton-rect selector"></div>
            <div class="skeleton-rect selector"></div>
          </div>
        </div>
        <div class="skeleton-expandable-item funnel">
          <div class="skeleton-rect funnel-bar long"></div>
          <div class="skeleton-rect funnel-bar medium"></div>
          <div class="skeleton-rect funnel-bar short"></div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: "DashboardSkeleton",
};
</script>

<style lang="scss" scoped>
.dashboard-skeleton-wrapper {
  padding: 20px;
  margin-top: 37px;
  position: fixed;
  top: 37px;
  left: 73px;
  right: 0;
  height: 100vh;
  overflow-y: hidden;
  background: white;
  z-index: 200;
}

@keyframes pulse {
  0% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.6;
  }
}

.skeleton-rect {
  background-color: #e0e0e0;
  border-radius: 4px;
  margin-bottom: 10px;
  animation: pulse 1.5s infinite ease-in-out;
}

.skeleton-banner {
  @extend .skeleton-rect;
  height: 50px;
  margin-bottom: 20px;
}

.skeleton-main-content-wrapper {
}

.skeleton-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  .title {
    height: 35px;
    width: 30%;
  }
  .skeleton-buttons-header {
    display: flex;
    .button {
      height: 35px;
      width: 120px;
      margin-left: 10px;
    }
  }
}

.skeleton-dashboard-filters {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 30px;
  gap: 20px;

  .filter-item {
    height: 30px;
    flex-grow: 1;
  }
  .datepicker {
    width: 25%;
  }
  .device-selector {
    width: 15%;
  }
  .campaign-select {
    width: 35%;
  }
  .export-button {
    width: 10%;
  }
}

.skeleton-dashboard-frames {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 30px;
  .frame-item {
    height: 100px;
    flex: 1;
  }
}

.skeleton-expandable-wrapper {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, auto);
  gap: 24px;
  width: 100%;
  margin-bottom: 60px;

  .skeleton-expandable-item {
    border: 2px solid #e0e0e0;
    border-radius: 9px;
    padding: 20px;
    box-sizing: border-box;
    min-height: 220px;

    &.chart {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .chart-area {
        height: 70%;
        margin-bottom: 10px;
      }
      .skeleton-chart-selectors {
        display: flex;
        justify-content: space-around;
        .selector {
          height: 20px;
          width: 25%;
          margin-bottom: 0;
        }
      }
    }

    &.funnel {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      .funnel-bar {
        height: 20px;
        border-radius: 4px;
        margin-bottom: 10px;
        background-color: #d0d0d0;
        &.long {
          width: 80%;
        }
        &.medium {
          width: 60%;
        }
        &.short {
          width: 40%;
        }
      }
    }

    .expandable-title {
      height: 20px;
      width: 40%;
      margin-bottom: 15px;
    }
    .expandable-line {
      height: 15px;
      width: 90%;
      margin-bottom: 8px;
      &.short {
        width: 60%;
      }
    }
  }
}
</style>
